import React, { createContext, FunctionComponent, useRef } from "react";
import DriverSocket from "./socket";

const DriverSocketContext = createContext<DriverSocket | undefined>(undefined);

export const DriverSocketProvider: FunctionComponent<{
  url: string,
  token?: string,
}> = ({ children, url, token }) => {
  const driverSocket = useRef(new DriverSocket({ url, token }))
  driverSocket.current.update({ url, token });
  return (
    <DriverSocketContext.Provider
      value={driverSocket.current}
    >
      { children }
    </DriverSocketContext.Provider>
  );
};

export default DriverSocketContext;
